var _rect, _g, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotificationMining({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    fill: "#FFE4D2",
    fillOpacity: 0.06
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6538_181334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.18931 19.0453C7.98962 16.9781 8.71522 14.9286 10.171 13.4475L11.75 11.8685H11.7502C12.2114 11.5843 12.609 11.2083 12.9185 10.7635C13.4689 9.63912 13.7686 8.40856 13.7964 7.15707C13.7964 7.15707 14.746 7.1591 16.1415 8.55485V8.5546C16.9126 9.23716 17.4467 10.1473 17.6666 11.1533C16.2412 10.9936 14.8103 11.3998 13.681 12.284C12.7527 13.2124 12.121 13.9253 11.7942 14.3082C11.6211 14.5114 11.5338 14.6215 11.5338 14.6215C11.5338 14.6213 9.19351 15.0594 8.18927 19.0452L8.18931 19.0453Z",
    fill: "#FF5C01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18424 19.7068L8.0377 19.0802C7.81929 16.9654 8.55754 14.8638 10.0507 13.3503L11.6718 11.7348C12.1114 11.463 12.4908 11.1043 12.7871 10.6809C13.3358 9.6144 13.6261 8.43425 13.6347 7.23512L13.6517 7H13.7967C14.7652 7.164 15.6399 7.67829 16.2534 8.4456C17.0511 9.15168 17.6011 10.0952 17.8231 11.1372L17.8433 11.3295L17.65 11.3072C16.2717 11.1539 14.888 11.5439 13.7927 12.3947C12.8484 13.339 12.2109 14.0616 11.9143 14.4086L11.6569 14.7173L11.6212 14.7644L11.5643 14.7732C11.542 14.7778 9.3055 15.2566 8.34123 19.0826L8.18424 19.7068ZM11.8482 11.9923L10.2818 13.5586H10.2821C9.15226 14.8281 8.45836 16.4261 8.30196 18.1185C9.32111 15.1584 11.0958 14.5699 11.4478 14.4804L11.6771 14.2073C12.0428 13.7778 12.6682 13.0796 13.571 12.1756C14.666 11.2834 16.0664 10.8547 17.4733 10.9812C17.2062 10.0954 16.7092 9.29616 16.0322 8.66549C15.4774 8.03025 14.7516 7.56808 13.9414 7.33399C13.908 8.55639 13.6038 9.75604 13.0508 10.8468C12.734 11.308 12.3242 11.6983 11.8482 11.9923L11.8482 11.9923Z",
    fill: "#FF5C01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8078 12.3959L28.8304 27.9539L27.038 29.7463L11.48 13.7237",
    fill: "#FF5C01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0301 30L26.9069 29.8694L11.356 13.8468L11.6098 13.6001L27.037 29.4918L28.5825 27.9535L12.6837 12.5264L12.9305 12.2723L29.0761 27.9463L27.0301 30Z",
    fill: "#FF5C01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1101 13.3464L10.3916 12.6279L11.7125 11.3073L12.4889 12.0764",
    fill: "#FF5C01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9868 13.4695L10.145 12.6351L11.7195 11.0603L12.6121 11.9529L12.3653 12.1997L11.7195 11.5538L10.6382 12.635L11.2332 13.23L10.9868 13.4695Z",
    fill: "#FF5C01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4597 19.0453C31.6594 16.9781 30.9338 14.9286 29.478 13.4475L27.899 11.8685C27.4377 11.5843 27.0401 11.2083 26.7306 10.7635C26.1801 9.63912 25.8804 8.40856 25.8526 7.15707C25.8526 7.15707 24.903 7.1591 23.5075 8.55485V8.5546C22.7364 9.23716 22.2023 10.1473 21.9824 11.1533C23.4078 10.9936 24.839 11.3998 25.968 12.284C26.8964 13.2124 27.5281 13.9253 27.8548 14.3082C28.0279 14.5114 28.1152 14.6215 28.1152 14.6215C28.1152 14.6213 30.4552 15.0594 31.4597 19.0452L31.4597 19.0453Z",
    fill: "#FF5C01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.467 19.7068L31.3103 19.0827C30.3453 15.2565 28.1085 14.7777 28.086 14.7734L28.029 14.7645L27.9931 14.7172L27.737 14.4084C27.4426 14.066 26.8081 13.3457 25.8575 12.3946C24.7609 11.5478 23.3788 11.158 22.0012 11.3074L21.8076 11.3296L21.8279 11.1373C22.0491 10.0951 22.5993 9.15161 23.3975 8.44572C24.0105 7.67834 24.8847 7.16385 25.8532 7.00012H25.9975L26.0154 7.24384C26.044 8.43741 26.3336 9.61043 26.8635 10.6805C27.1607 11.1037 27.5405 11.462 27.9799 11.7344L28.0113 11.7589L29.5897 13.3387C31.0883 14.8539 31.8308 16.9599 31.6136 19.0799L31.467 19.7068ZM28.2024 14.48C28.5547 14.5696 30.3291 15.1603 31.3492 18.1181H31.3495C31.1893 16.4212 30.4918 14.8197 29.358 13.5469L27.803 11.9919C27.3267 11.6976 26.9167 11.3073 26.5994 10.8464C26.0476 9.7551 25.7437 8.55577 25.7087 7.33357C24.8991 7.56818 24.174 8.03033 23.619 8.66481C22.9418 9.29525 22.4444 10.0945 22.178 10.9805C23.5849 10.8517 24.9857 11.2807 26.079 12.1753C27.0369 13.1333 27.6778 13.8579 27.9741 14.2071L28.2024 14.48Z",
    fill: "#FF5C01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8414 12.3959L10.8188 27.9539L12.6112 29.7463L28.1692 13.7237",
    fill: "#FF5C01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6199 30L10.5664 27.9465L10.697 27.8232L26.7189 12.2723L26.9657 12.5264L11.0669 27.9536L12.6124 29.4918L28.0396 13.6001L28.2934 13.8469L12.6199 30Z",
    fill: "#FF5C01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5399 13.3464L29.2585 12.6279L27.9305 11.3073L27.1611 12.0764",
    fill: "#FF5C01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6624 13.4695L28.4159 13.23L29.0109 12.635L27.9368 11.5538L27.2839 12.1997L27.0371 11.9529L27.9368 11.0603L29.5042 12.6351L28.6624 13.4695Z",
    fill: "#FF5C01"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#FF5C01"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6538_181334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotificationMining);
export default __webpack_public_path__ + "static/media/icon_notification_mining.551f165fef16ef47ac54dc7a25f938d2.svg";
export { ForwardRef as ReactComponent };